const sectionMarqueeTinoCss = `
[data-type='section-marquee-tino'] [data-attribute='card-container'] {
  --marquee-duration: 100s;
  padding: 40px 0;
}

[data-type='section-marquee-tino'] .wrap-content {
  overflow: hidden;
}

[data-type='section-marquee-tino'] .section-header {
  text-align: center;
  max-width: 700px;
  margin: 0 auto;
  margin-bottom: 40px;
}

[data-type='section-marquee-tino'] .section-header .section-title {
  font-size: 24px;
  font-weight: bold !important;
  margin-bottom: 10px;
}

[data-type='section-marquee-tino'] .section-header .line-stroke {
  max-width: 100%;
}

[data-type='section-marquee-tino'] .section-header .section-description {
  font-size: 18px;
  margin-top: 10px;
}

[data-type='section-marquee-tino'] .marquee-wrapper {
  overflow: hidden;
  width: 100%;
  display: flex;
}

[data-type='section-marquee-tino'] .marquee-wrapper:hover .slider-jk {
  animation-play-state: paused;
}

[data-type='section-marquee-tino'] .marquee-wrapper .slider-jk {
  display: flex;
  flex-shrink: 0;
  animation: marquee2 var(--marquee-duration) linear infinite;
  animation-play-state: running;
  max-width: max-content;
}

[data-type='section-marquee-tino'] .marquee-wrapper .slider-jk .track {
  flex-shrink: 0;
  width: 280px;
  margin-right: 40px;
}

[data-type='section-marquee-tino'] .marquee-wrapper .slider-jk .wrap-item .wrap-img {
  width: 100%;
  aspect-ratio: 1/1;
  overflow: hidden;
  position: relative;
  margin-bottom: 20px;
}

[data-type='section-marquee-tino'] .marquee-wrapper .slider-jk .wrap-item .wrap-img img {
  width: 100%;
  height: 100%;
  position: absolute;
  inset: 0;
  object-fit: contain;
}

[data-type='section-marquee-tino'] .marquee-wrapper .slider-jk .wrap-item .group-text {
  white-space: normal;
}

[data-type='section-marquee-tino'] .marquee-wrapper .slider-jk .wrap-item .group-text h1,
[data-type='section-marquee-tino'] .marquee-wrapper .slider-jk .wrap-item .group-text h2,
[data-type='section-marquee-tino'] .marquee-wrapper .slider-jk .wrap-item .group-text h3 {
  font-size: 20px;
}

@container (max-width: 1024px) {
  [data-type='section-marquee-tino'] .marquee-wrapper .slider-jk .track {
    width: 180px;
  }
}

@container (max-width: 768px) {
  [data-type='section-marquee-tino'] [data-attribute='card-container'] {
    padding: 16px 0;
  }

  [data-type='section-marquee-tino'] .section-header .section-title {
    font-size: 18px;
  }

  [data-type='section-marquee-tino'] .section-header .section-description {
    font-size: 14px;
  }

  [data-type='section-marquee-tino'] .marquee-wrapper .slider-jk .track {
    width: 140px;
  }

  [data-type='section-marquee-tino'] .marquee-wrapper .slider-jk .wrap-item .group-text h1,
  [data-type='section-marquee-tino'] .marquee-wrapper .slider-jk .wrap-item .group-text h2,
  [data-type='section-marquee-tino'] .marquee-wrapper .slider-jk .wrap-item .group-text h3 {
    font-size: 16px;
  }
}

@keyframes marquee2 {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50%);
  }
}
`;
export default sectionMarqueeTinoCss;
